module.exports = __webpack_public_path__ + "img/death_causes.5f084647.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/death_causes.gif
// module id = EBvJ
// module chunks = 0